import * as d3 from 'd3';

export function defineTexturedGlassPatterns(svg, glassDesign) {
    const id = glassDesign.toLowerCase().replace(/\s/g, '') + 'Pattern';
    const defs = svg.select('defs').empty()
      ? svg.append('defs')
      : svg.select('defs');
  
    // Avoid duplicate patterns
    if (!defs.select(`#${id}`).empty()) return;
  
    switch (glassDesign) {
      case 'Frosted': {
        const pattern = defs.append('pattern')
          .attr('id', id)
          .attr('patternUnits', 'userSpaceOnUse')
          .attr('width', 6)
          .attr('height', 6);
  
        pattern.append('rect')  // ← base background
          .attr('width', 6)
          .attr('height', 6)
          .attr('fill', 'white');  // or light grey

        pattern.append('path')
          .attr('d', 'M0,0 L6,6 M6,0 L0,6')
          .attr('stroke', '#ccc')
          .attr('stroke-width', 0.5);
        break;
      }
  
      // Future designs go here:
      case 'Sandblast': { //Subtle diagonal lines for a soft grainy texture.
        const pattern = defs.append('pattern')
          .attr('id', id)
          .attr('patternUnits', 'userSpaceOnUse')
          .attr('width', 8)
          .attr('height', 8);

          pattern.append('rect')  // ← base background
          .attr('width', 8)
          .attr('height', 8)
          .attr('fill', 'white');  // or light grey
      
        pattern.append('path')
          .attr('d', 'M0,8 L8,0')
          .attr('stroke', '#bbb')
          .attr('stroke-width', 0.5);
        break;
      }
      case 'Chinchilla': { //Vertical organic waves (simulated with sine curves is hard, so simplified with zigzag).
        const pattern = defs.append('pattern')
          .attr('id', id)
          .attr('patternUnits', 'userSpaceOnUse')
          .attr('width', 4)
          .attr('height', 8);

          pattern.append('rect')  // ← base background
          .attr('width', 4)
          .attr('height', 8)
          .attr('fill', 'white');  // or light grey

        pattern.append('path')
          .attr('d', 'M2,0 L0,4 L2,8 L4,4 Z')
          .attr('stroke', '#aaa')
          .attr('fill', 'none')
          .attr('stroke-width', 0.6);
        break;
      }
      case 'Gluechip': { //Jagged crystal-like look with crisscross.
        const pattern = defs.append('pattern')
          .attr('id', id)
          .attr('patternUnits', 'userSpaceOnUse')
          .attr('width', 6)
          .attr('height', 6);
      
          pattern.append('rect')  // ← base background
          .attr('width', 6)
          .attr('height', 6)
          .attr('fill', 'white');  // or light grey

        pattern.append('path')
          .attr('d', 'M0,0 L6,6 M6,0 L0,6')
          .attr('stroke', '#aaa')
          .attr('stroke-width', 0.5);
      
        break;
      }
      case 'Rain blast': { //Vertical lines, like streaks of rain.
        const pattern = defs.append('pattern')
          .attr('id', id)
          .attr('patternUnits', 'userSpaceOnUse')
          .attr('width', 4)
          .attr('height', 8);
      
        pattern.append('rect')  // ← base background
          .attr('width', 4)
          .attr('height', 8)
          .attr('fill', 'white');  // or light grey

        pattern.append('path')
          .attr('d', 'M2,0 L2,8')
          .attr('stroke', '#bbb')
          .attr('stroke-width', 0.6);
        break;
      }
      case 'Pinhead': { //Tight dot pattern, classic "pinhead" look.
        const pattern = defs.append('pattern')
          .attr('id', id)
          .attr('patternUnits', 'userSpaceOnUse')
          .attr('width', 4)
          .attr('height', 4);

        pattern.append('rect')  // ← base background
          .attr('width', 4)
          .attr('height', 4)
          .attr('fill', 'white');  // or light grey

        pattern.append('circle')
          .attr('cx', 2)
          .attr('cy', 2)
          .attr('r', 0.5)
          .attr('fill', '#bbb');
        break;
      }
      case 'Acid Edged': { //Organic cloudy appearance, simulated with overlapping dots.
        const pattern = defs.append('pattern')
          .attr('id', id)
          .attr('patternUnits', 'userSpaceOnUse')
          .attr('width', 6)
          .attr('height', 6);
 
        pattern.append('rect')  // ← base background
          .attr('width', 6)
          .attr('height', 6)
          .attr('fill', 'white');  // or light grey

        pattern.append('circle')
          .attr('cx', 2)
          .attr('cy', 2)
          .attr('r', 0.8)
          .attr('fill', '#ccc');
      
        pattern.append('circle')
          .attr('cx', 4)
          .attr('cy', 4)
          .attr('r', 0.6)
          .attr('fill', '#ccc');
        break;
      }
      case 'AccordionOld': { 
        const pattern = defs.append('pattern')
          .attr('id', id)
          .attr('patternUnits', 'userSpaceOnUse')
          .attr('width', 10)
          .attr('height', 10);
      
        pattern.append('rect')
          .attr('width', 10)
          .attr('height', 10)
          .attr('fill', 'white');
      
        pattern.append('path')
          .attr('d', 'M0,10 L5,0 L10,10')
          .attr('stroke', '#999')
          .attr('fill', 'none')
          .attr('stroke-width', 0.8);
      
        break;
      }
      case 'AccordionHor': {
        const pattern = defs.append('pattern')
          .attr('id', id)
          .attr('patternUnits', 'userSpaceOnUse')
          .attr('width', 12)  // ширина одной складки
          .attr('height', 20);
      
        pattern.append('rect')
          .attr('width', 12)
          .attr('height', 20)
          .attr('fill', 'white');
      
        // Зигзагообразные линии гармошки
        pattern.append('path')
          .attr('d', `
            M0,0 L3,10 L0,20
            M3,0 L6,10 L3,20
            M6,0 L9,10 L6,20
            M9,0 L12,10 L9,20
          `)
          .attr('stroke', '#aaa')
          .attr('stroke-width', 1)
          .attr('fill', 'none');
      
        break;
      }
      case 'AccordionVer': { 
        const pattern = defs.append('pattern')
          .attr('id', id)
          .attr('patternUnits', 'userSpaceOnUse')
          .attr('width', 20)  // ширина области
          .attr('height', 12); // высота одной складки
      
        pattern.append('rect')
          .attr('width', 20)
          .attr('height', 12)
          .attr('fill', 'white');
      
        // Зигзагообразные вертикальные складки
        pattern.append('path')
          .attr('d', `
            M0,0 L10,3 L20,0
            M0,3 L10,6 L20,3
            M0,6 L10,9 L20,6
            M0,9 L10,12 L20,9
          `)
          .attr('stroke', '#aaa')
          .attr('stroke-width', 1)
          .attr('fill', 'none');
      
        break;
      }
      case 'AccordionShadow': { 
        const pattern = defs.append('pattern')
          .attr('id', id)
          .attr('patternUnits', 'userSpaceOnUse')
          .attr('width', 20)   // ширина паттерна
          .attr('height', 12); // высота одной "гармошки"
      
        pattern.append('rect') // фон
          .attr('width', 20)
          .attr('height', 12)
          .attr('fill', 'white');
      
        // Многоступенчатый зигзаг вертикально
        pattern.append('path')
          .attr('d', `
            M0,0 L10,3 L20,0
            M0,3 L10,6 L20,3
            M0,6 L10,9 L20,6
            M0,9 L10,12 L20,9
          `)
          .attr('stroke', '#aaa')
          .attr('stroke-width', 0.7)
          .attr('fill', 'none');
      
        break;
      }
      
  
      default:
        console.warn('Unknown textured glass pattern:', glassDesign);
    }
  }
  
export function getGlassDesign( doorData)
{
    let glassDesign;
    switch (doorData?.glass?.glassType1.label)
    {
      case 'Textured': {
        glassDesign = doorData?.glass?.texturedDesign1.value;
        break;
      }
      case 'Tinted': {
        glassDesign = doorData?.glass?.tintedDesign1.value;
        break;
      }
    }
    return glassDesign;
}